import { v4 as uuidv4 } from "uuid";
import supportImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/support_image_placeholder.png";
import userImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/user_image_placeholder.png";
import usersImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/users_image_placeholder.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getBackgroundColorOptions,
  getBorderColorOptions,
} from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBlockPrimaryStyleOptions } from "../../constants";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: userImagePlaceholder,
    },
    h5Text: "Curriculum strategy",
    pText:
      "Partner 1:1 with an experienced advisor to shape your content, define measurable outcomes, and map a learner journey that delivers meaningful results.",
  },
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
    },
    h5Text: "Design workshops",
    pText:
      "Test your ideas in a collaborative setting. These guided sessions help you refine your flow, integrate peer feedback, and align your delivery with professional standards.",
  },
  {
    image: {
      signedId: "",
      placeholder: supportImagePlaceholder,
    },
    h5Text: "Peer circles",
    pText:
      "Join structured cohorts designed to keep you accountable. Through facilitated check-ins and shared progress markers, you'll stay on track—together.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Build with structure. Grow with community.",
        }),
        createPBlock({
          text: "Advance your program with expert support and a network of peers who bring clarity, consistency, and shared purpose to every step of your journey.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card =>
        createCardBlock({
          ...card,
          styles: {
            backgroundColor: getBackgroundColorOptions({
              defaultValue: "var(--theme-website-color-2)",
            }),
            borderColor: getBorderColorOptions({
              defaultValue: "var(--theme-website-color-1)",
            }),
          },
        }),
      ),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
